import React from "react"
import { Link } from "react-router-dom"
import { ArrowLeft } from "lucide-react"

export default function NotFoundPage() {
  return (
    <div className="flex min-h-svh items-center justify-center bg-[#f0f2f8] px-4">
      <div className="text-center">
        <h1 className="text-[72px] font-extrabold tracking-tight text-slate-900">404</h1>
        <div className="mx-auto my-4 h-px w-16 bg-slate-300" />
        <p className="text-[16px] text-slate-600">This page could not be found.</p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#2d4fd6] px-6 py-2.5 text-[14px] font-semibold text-white transition-colors hover:bg-[#2440c0]"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to home
        </Link>
      </div>
    </div>
  )
}
